import React, { Component } from 'react';
import * as d3 from 'd3';
import "./table.css";

import ImgLeaf from '../images/votes/leaf.png'
import ImgTicket from '../images/votes/ticket.png'
import ImgBells from '../images/votes/bells.png'

class VillagerTable extends Component {
  constructor(props){
      super(props);
      this.tableRef = React.createRef();
      this.state = {
        selectedRange:`${this.props.startRange}-${this.props.endRange}`,
      };


      this.allVillagers = this.props.villagers;
      this.tableId = this.props.id;

      this.tableHeaders = [
        {'name': 'Name',
        'label':'Ranking'},
        {'name': 'Poll_Ranking_2020_21',
        'label':'Poll Ranking'},
        {'name': 'Nookazon NMT Ranking',
        'label':'NMT Ranking'},
        {'name': 'Nookazon Bells Ranking',
        'label':'Bells Ranking'}
      ];

      this.numberOfVillagers = this.allVillagers.length;
      this.startMin = Number(this.props.startRange);
      this.maxDisplay = (Number(this.props.endRange)-Number(this.props.startRange)+1);
      //let noOfOptions = Math.ceil(numberOfVillagers/maxDisplay);
      this.rangeOptions = this.generateRangeOptions(this.startMin,this.numberOfVillagers,this.maxDisplay)

      this.selectRangeHandler = this.selectRangeHandler.bind(this);
      this.generateRangeOptions = this.generateRangeOptions.bind(this);
      //this.updateTable =  this.updateTable.bind(this);
   }

   componentDidMount() {
     this.table = d3.select(this.tableRef.current);

     let initialVillagers = this.allVillagers.filter(v => v.Average_Popularity_Ranking <= this.maxDisplay);

     this.drawTable(initialVillagers);
   }

  generateRangeOptions(init,end,step){
    let initIndex = init-1;
    let noOfOptions = Math.ceil((end-(initIndex))/step);
    return ([...Array(noOfOptions).keys()].map(i => ({
      'startRank':initIndex+(i)*step+1,
      'endRank':(i === (noOfOptions-1))?end:initIndex+(i+1)*step
    })));
  }


  selectRangeHandler(event){
     let selectedRange = event.target.value;
     this.setState({selectedRange: selectedRange});


     let selectedRangeArr = selectedRange.split("-");
     //console.log('selectedRangeArr ' + selectedRangeArr)
     let newStartRank = selectedRangeArr[0],
         newEndRank = selectedRangeArr[1];

     let selectedVillagers = this.allVillagers.filter(v => v.Average_Popularity_Ranking >= newStartRank && v.Average_Popularity_Ranking <= newEndRank );

     this.setState({totalNo:selectedVillagers.length})
     this.updateTable(selectedVillagers);
  }

  updateTable(selectedVillagers){
     selectedVillagers.sort((a, b) => parseFloat(a.Average_Popularity_Ranking) - parseFloat(b.Average_Popularity_Ranking))
     let tableHeaders = this.tableHeaders;
     var table = this.table;
     table.selectAll('tbody').remove()

     var tbody = table.append('tbody');

     var rows = tbody.selectAll('tr')
     .data(selectedVillagers)
     .enter()
     .append('tr');

     rows.selectAll('td')
     	  .data(function (row) {
     	    return tableHeaders.map((column, i) => {
             let rowHTML = '';
             switch (column.name) {
               case 'Name':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Average_Popularity_Ranking}</span><img class='villager-profile' alt='Profile photo of ${row.name}' src='${process.env.PUBLIC_URL}/images/face/face-image-${row.id}.png'/><span class='pill'>${row.name}</span></span>`
                 //rowHTML = `<span><img alt='Profile photo of ${row.name}' src='${row.image_url}'/><span class='pill'>${row.name}</span></span>`
                 break;
               case 'Poll_Ranking_2020_21':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Poll_Ranking_2020_21}</span> <span class='count'><img class='vote-icon' alt='Vote icon' src='${ImgLeaf}'/>${row.Total_Poll_Votes_2020_21}</span></span>`
                 break;
               case 'Nookazon NMT Ranking':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Nookazon_NMT_Price_Ranking}</span> <span class='count'><img class='vote-icon' alt='Vote icon' src='${ImgTicket}'/>${row.Nookazon_average_price_NMT}</span></span>`
                 break;
               case 'Nookazon Bells Ranking':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Nookazon_Bells_Price_Ranking}</span> <span class='count'><img class='vote-icon' alt='Vote icon' src='${ImgBells}'/>${row.Nookazon_average_price_Bells}</span></span>`
                 break;
               default:
                 console.log('Sorry, we are out of ' + column + '.');
             }
     	      return {column: column.name, value: rowHTML};
     	    });
     	  })
     	  .enter()
     	  .append('td')
         .html(d => `${d.value}`)
         .attr("class", function(d) {
             let className = '';
             switch (d.column) {
               case 'Name':
                 className = `table-cell table-col-name`
                 break;
               case 'Poll_Ranking_2020_21':
                 className = `table-cell table-col-poll`
                 break;
               case 'Nookazon NMT Ranking':
                 className = `table-cell table-col-nmt`
                 break;
               case 'Nookazon Bells Ranking':
                 className = `table-cell table-col-bell`
                 break;
               default:
                 console.log('Sorry, we are out of ' + d + '.');
             }
             return className;
           })


  }

  drawTable(loadVillagers){
     let tableHeaders = this.tableHeaders;
     // select the DIV with the ID "vote-summary" and append a table
     var table = this.table.classed('table', true)
     // append <thead><tr></tr></thead> to the table
     var thead = table.append('thead').append('tr');
     // append <tbody></tbody> to the table
     var tbody = table.append('tbody');

     // generate headers
     thead.selectAll('th')
     .data(tableHeaders)
     .enter()
     .append('th')
     .text(d => d.label)
     .classed('table-header', true)

     // generate table body
     var rows = tbody.selectAll('tr')
     .data(loadVillagers)
     .enter()
     .append('tr');

     var cells = rows.selectAll('td')
     	  .data(function (row) {
     	    return tableHeaders.map((column, i) => {
             let rowHTML = '';
             switch (column.name) {
               case 'Name':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Average_Popularity_Ranking}</span><img class='villager-profile' alt='Profile photo of ${row.name}' src='${process.env.PUBLIC_URL}/images/face/face-image-${row.id}.png'/><span class='pill'>${row.name}</span></span>`
                 //rowHTML = `<span><img alt='Profile photo of ${row.name}' src='${row.image_url}'/><span class='pill'>${row.name}</span></span>`
                 break;
               case 'Poll_Ranking_2020_21':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Poll_Ranking_2020_21}</span> <span class='count'><img class='vote-icon' alt='Vote icon' src='${ImgLeaf}'/>${row.Total_Poll_Votes_2020_21}</span></span>`
                 break;
               case 'Nookazon NMT Ranking':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Nookazon_NMT_Price_Ranking}</span> <span class='count'><img class='vote-icon' alt='Vote icon' src='${ImgTicket}'/>${row.Nookazon_average_price_NMT}</span></span>`
                 break;
               case 'Nookazon Bells Ranking':
                 rowHTML = `<span class='cell-wrapper'><span class='ranking'>${row.Nookazon_Bells_Price_Ranking}</span> <span class='count'><img class='vote-icon' alt='Vote icon' src='${ImgBells}'/>${row.Nookazon_average_price_Bells}</span></span>`
                 break;
               default:
                 console.log('Sorry, we are out of ' + column + '.');
             }
     	      return {column: column.name, value: rowHTML};
     	    });
     	  })
     	  .enter()
     	  .append('td')
         .html(d => `${d.value}`)
         .attr("class", function(d) {
             let className = '';
             switch (d.column) {
               case 'Name':
                 className = `table-cell table-col-name`
                 break;
               case 'Poll_Ranking_2020_21':
                 className = `table-cell table-col-poll`
                 break;
               case 'Nookazon NMT Ranking':
                 className = `table-cell table-col-nmt`
                 break;
               case 'Nookazon Bells Ranking':
                 className = `table-cell table-col-bell`
                 break;
               default:
                 console.log('Sorry, we are out of ' + d + '.');
             }
             return className;
           })
   }


  render() {
    //let getVillagerAvatar = this.props.villagers.find(v => v.name == this.props.villager);
    let classlist;
    //let activeClass = this.props.selected?'active':'';
    classlist = `table villager-table ${this.props.classList?this.props.classList:''}`

    return (
      <div className='tableWrapper'>
        {this.props.hasControl &&
          <div className='select-dropdown'>
            <select
              id="selectRange"
              name="selectRange"
              value={this.state.selectedRange}
              onChange={this.selectRangeHandler.bind(this)} >
                {this.rangeOptions.map((item, index) => (
                  <option key={index} value={`${item.startRank}-${item.endRank}`}>
                  Popularity Tier {index+1}
                  </option>
                ))}
             </select>
           </div>
        }
        <div className='scrollWrapper'>
          <table ref={this.tableRef}  className={classlist} id={this.tableId} ></table>
        </div>
     </div>

    )
  }
}

export default VillagerTable;
